import React from 'react';
import styled from 'styled-components';
import ClickAnimation from '../../ClickAnimation';
import { CarouselProps } from '../carousel.model';

export const CarouselPage: React.FC<CarouselProps> = ({ slides, current, goto }) => {
	return (
		<>
			<StyledPageSliderContainer>
				{slides.map((item, index) => (
					<ClickAnimation key={index}>
						<StyledPageSliderItem
							className={index === current && 'is-active'}
							onClick={() => goto(index)}
						></StyledPageSliderItem>
					</ClickAnimation>
				))}
			</StyledPageSliderContainer>
		</>
	);
};

const StyledPageSliderContainer = styled.div`
	display: flex;
	z-index: 1;
	align-items: flex-end;
	justify-content: center;
	margin-top: 24px;
`;

const StyledPageSliderItem = styled.div`
	height: 4px;
	width: 24px;
	background: ${(props) => props.theme.color.grey[600]};
	margin-left: 8px;
	border-radius: 8px;
	cursor: pointer;

	&.is-active {
		background: white;
	}

	&:hover {
		transition: 0.3s;
		transform: scale(1.2, 1.2);
	}
`;
export default CarouselPage;
